export const PlayWithCircle = () => {
  return (
    <svg
      width='40'
      height='40'
      viewBox='0 0 40 40'
      fill='none'
      xmlns='http://www.w3.org/2000/svg'
      className={'PlayWithCircle'}
    >
      <rect width='40' height='40' rx='20' fill='black' fillOpacity='0.5' />
      <path
        d='M29.0853 19.1443C29.7286 19.5334 29.7286 20.4666 29.0853 20.8557L16.2675 28.6084C15.6011 29.0115 14.75 28.5316 14.75 27.7527L14.75 12.2473C14.75 11.4684 15.6011 10.9885 16.2675 11.3916L29.0853 19.1443Z'
        fill='white'
      />
    </svg>
  )
}
